export const mTagAssistantImportModes = {
  singleTag: 'singleTag',
  multiTag: 'multiTag',
}

export const mTagAssistantMatchKeyTypes = {
  phone: 'phone',
}

export const mTagAssistantImportTaskStatuses = ['editing', 'queued', 'executing', 'done', 'failed']

export const mTagAssistantTagMappingDecisions = ['mapExisting', 'createNew', 'skip']

export const mTagAssistantJobTypes = [
  'autoLabelSync',
  'uploadApplyTag',
  'deleteTag',
]

export const mTagAssistantOperationTypes = [
  'autoLabelTPlus1Sync',
  'manualRuleExecute',
  'uploadApplyTagFull',
  'uploadApplyTagSimple',
  'deleteTag',
]

export const mTagAssistantBatchStatuses = ['queued', 'running', 'succeeded', 'partialSucceeded', 'failed']

export const mTagAssistantBatchOrigins = ['user', 'system']

export const mTagAssistantAutoRuleMatchTypes = ['all', 'any']

export const mTagAssistantConditionSources = ['appointment', 'sales', 'externalTransaction']

export const mTagAssistantAchievementConstraintModes = ['unlimited', 'relative', 'absolute']

export const mTagAssistantRelativeUnits = ['day', 'month', 'year']

export const mTagAssistantAutoRunTimeSlots = ['morning', 'afternoon', 'night']

export const batchStatusDisplay = {
  queued: '排隊中',
  running: '執行中',
  succeeded: '已完成',
  partialSucceeded: '部分失敗',
  failed: '失敗',
}

export const batchStatusType = {
  queued: 'info',
  running: 'warning',
  succeeded: 'primary',
  partialSucceeded: 'danger',
  failed: 'danger',
}

// uploadApplyTagSimple 與 uploadApplyTagFull 對使用者顯示為同一種操作
export const operationTypeDisplay = {
  manualRuleExecute: '依規則批次貼/撕標',
  autoLabelTPlus1Sync: '自動化',
  uploadApplyTagSimple: '名單標籤匯入',
  uploadApplyTagFull: '名單標籤匯入',
  deleteTag: '刪除標籤',
}

// 「名單標籤匯入」以 jobType='uploadApplyTag' 涵蓋 simple + full 兩種 operationType
export const operationTypeFilterOptions = [
  { label: '依規則批次貼/撕標', value: 'manualRuleExecute' },
  { label: '自動化', value: 'autoLabelTPlus1Sync' },
  { label: '名單標籤匯入', value: 'uploadApplyTag' },
  { label: '刪除標籤', value: 'deleteTag' },
]

export const autoRunTimeSlotDisplay = {
  morning: '上午時段',
  afternoon: '下午時段',
  night: '深夜時段',
}

// 標籤總覽頁名單匯入用
export const matchKeyTypeDisplay = {
  phone: '手機號碼',
}

// 名單標籤匯入（貼/撕標助手）頁用，明確標示上傳檔案同時含手機號碼與標籤名稱
export const importTaskMatchKeyTypeDisplay = {
  phone: '手機號碼＋標籤名稱',
}

export const importTaskStatusDisplay = {
  editing: '編輯中',
  queued: '排隊中',
  executing: '執行中',
  done: '完成',
  failed: '失敗',
}

export const mTagAssistantErrors = {
  autoTagCannotImport: (name) =>
    `標籤「${name}」為自動標籤，無法透過名單方式操作。請修改標籤名稱，或至貼/撕標助手以依規則方式操作。`,
  manualTagCannotSetRule: (name) =>
    `標籤「${name}」為手動標籤，無法設定規則。請使用其他標籤名稱。`,
  manualTagAlreadyExists: (name) =>
    `已有名單標籤「${name}」，可前往該標籤上傳名單。`,
}
